// extracted by mini-css-extract-plugin
export var body = "Highlights-module--body--7b1bd";
export var button = "Highlights-module--button--e2759 Button-module--button--adebe Button-module--small--93dd7";
export var description = "Highlights-module--description--9794d";
export var grid = "Highlights-module--grid--4fbee";
export var grid_3_columns = "Highlights-module--grid_3_columns--e7470";
export var image = "Highlights-module--image--34f7c";
export var title = "Highlights-module--title--a6ba0";
export var wrapper = "Highlights-module--wrapper--75aff";